// extracted by mini-css-extract-plugin
module.exports = {"inspect-loader":"inspect-loader___3Ae2M"};